import styles from "./ds.module.css";

export interface TabSpec { value: string; label: string }

/** Underline tabs: the active one gets a 2px indigo underline and indigo text. */
export function Tabs({ tabs, value, onChange, bare = false }: {
    tabs: TabSpec[]; value: string; onChange: (value: string) => void; bare?: boolean;
}) {
    return (
        <div className={`${styles.tabs} ${bare ? styles.tabsBare : ""}`} role="tablist">
            {tabs.map((t) => (
                <button key={t.value} type="button" role="tab" aria-selected={t.value === value}
                    className={`${styles.tab} ${t.value === value ? styles.tabOn : ""}`}
                    onClick={() => onChange(t.value)}>
                    {t.label}
                </button>
            ))}
        </div>
    );
}

export function SegmentedControl({ options, value, onChange }: { options: string[]; value: string; onChange: (value: string) => void }) {
    return (
        <div className={styles.segmented} role="radiogroup">
            {options.map((o) => (
                <button key={o} type="button" role="radio" aria-checked={o === value}
                    className={`${styles.segment} ${o === value ? styles.segmentOn : ""}`} onClick={() => onChange(o)}>
                    {o}
                </button>
            ))}
        </div>
    );
}
